import { groq } from "next-sanity"

import { getListingByBranch } from "@/graphql/schemas/shared/utils/getVariantListing"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqArticleProjection } from "../../shared/sanity/article.projection"
import { getArticleConfiguration } from "../../shared/utils/getArticleInformation"
import { addColorAttribute } from "./utils/attributes"

export const queryArticle = {
  async article(parent, args, context, info) {
    const {
      lang = AppSettings.defaultLocale(),
      cdn = true,
      sku,
      customerId = null,
      customerGroup,
      loggedInBranch,
    } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    if (!sku) return null

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    let article
    article = await client.fetch(
      groq`*[_type=="article" && sku==$sku ${draftsFilter}][0] {
        ...,
        ${groqArticleProjection()}
      }`,
      { sku },
    )

    if (typeof article?.modifiedAt === "string") article.modifiedAt = new Date(article.modifiedAt)

    if (article) article.customerPrice = { customerId, customerGroup, sku: article.sku }

    if (article?.sku) {
      const articleConfig = await getArticleConfiguration({
        sku: article?.sku,
        productKey: article?.productRef?.key,
      })

      article.amountBilling = articleConfig?.amountBilling
      article.sellableInDecimals = articleConfig?.sellableInDecimals

      const listingVariant = await getListingByBranch({
        variants: [article],
        branchKey: loggedInBranch,
      })

      if (listingVariant && listingVariant[0]) {
        article.availability = listingVariant[0]?.availability || "unknown"
      }
    }

    return addColorAttribute(article)
  },
}
